const hideFilterArray = ["Community", "tag"];
export const CONTENT_CONSTANTS = {
  ALL: "ALL",
  PUBLISHED: "PUBLISHED",
  DRAFT: "DRAFT",
  UNPUBLISHED: "UNPUBLISHED",
};

export const STATUS_FILTER_OPTIONS = [
  { value: "PUBLISHED", labelKey: "published" },
  { value: "DRAFT", labelKey: "draft" },
  { value: "UNPUBLISHED", labelKey: "unpublished" },
  { value: "SCHEDULED_PUBLISH", labelKey: "scheduled_publish" },
  { value: "SCHEDULED_UNPUBLISH", labelKey: "scheduled_unpublish" },
];

/**
 * "Sort By" menu options for the content listing (KIWI-6058). `value` is the
 * key persisted in the ?sort= URL param and mapped to API variables by
 * mapFetchALL; `labelKey` is the i18n key. NEWEST is the default and matches
 * the pre-existing lastModificationDate DESC ordering.
 */
export const CONTENT_SORT_OPTIONS = [
  { value: "newest", labelKey: "newest_first" },
  { value: "oldest", labelKey: "oldest_first" },
  { value: "title_az", labelKey: "title_a_z" },
  { value: "title_za", labelKey: "title_z_a" },
];

export const DEFAULT_CONTENT_SORT = "newest";

/**
 * pass contentType
 * if u want hide in filter in content type add in into array
 * @param type
 */
export const contentTypeBasedHideFilter = (type = "") => {
  return !hideFilterArray.some((ele) => ele === type);
};

export const contentTypeSearchBox = (type) => {
  return ["tag", "Sites"].includes(type);
};
